import EnterpriseObjectMemberMetadata from "../../EnterpriseObjectMemberMetadata";
import EnterpriseObjectMetadata from "../../EnterpriseObjectMetadata";

class ProjectPlanEnterpriseObjectMetadata extends EnterpriseObjectMetadata {

    constructor() {
        super();

        this.name = "ProjectPlan";
        this.primaryEnterpriseComponent = "ProjectPlan";

        let eom: EnterpriseObjectMemberMetadata = new EnterpriseObjectMemberMetadata();
        eom.name = "ProjectPlan";
        eom.enterpriseComponent = "ProjectPlan";
        eom.relationship = undefined;
        this.enterpriseComponentMembers.set(eom.name, eom);

        eom = new EnterpriseObjectMemberMetadata();
        eom.name = "ProjectPlanChart";
        eom.enterpriseComponent = "ProjectPlanChart";
        eom.relationship = undefined;
        this.enterpriseComponentMembers.set(eom.name, eom);

        eom = new EnterpriseObjectMemberMetadata();
        eom.name = "ProjectPlanAuditLog";
        eom.enterpriseComponent = "ProjectPlanAuditLog";
        eom.relationship = "ProjectPlanProjectPlanAuditLog";
        this.enterpriseComponentMembers.set(eom.name, eom);

        eom = new EnterpriseObjectMemberMetadata();
        eom.name = "ProjectPlanPhase";
        eom.enterpriseComponent = "ProjectPlanPhase";
        eom.relationship = "ProjectPlanProjectPlanPhase";
        this.enterpriseComponentMembers.set(eom.name, eom);

        eom = new EnterpriseObjectMemberMetadata();
        eom.name = "ProjectPlanPhaseMilestone";
        eom.enterpriseComponent = "ProjectPlanPhaseMilestone";
        eom.relationship = "ProjectPlanPhaseProjectPlanPhaseMilestone";
        this.enterpriseComponentMembers.set(eom.name, eom);

        eom = new EnterpriseObjectMemberMetadata();
        eom.name = "ProjectPlanPhaseAttachment";
        eom.enterpriseComponent = "ProjectPlanPhaseAttachment";
        eom.relationship = "ProjectPlanPhaseProjectPlanPhaseAttachment";
        this.enterpriseComponentMembers.set(eom.name, eom);

        eom = new EnterpriseObjectMemberMetadata();
        eom.name = "ProjectPlanPhaseMilestoneReference";
        eom.enterpriseComponent = "ProjectPlanPhaseMilestoneReference";
        eom.relationship = "ProjectPlanPhaseMilestoneProjectPlanPhaseMilestoneReference";
        this.enterpriseComponentMembers.set(eom.name, eom);
    }
}

export default ProjectPlanEnterpriseObjectMetadata;